import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { hasModuleAccess } from '../utils/moduleAccess';

export default function ProtectedRoute({ children, requiredModule = null }) {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const permissions = useAuthStore((state) => state.permissions);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Check module access if requiredModule is specified
  if (requiredModule && user) {
    const isAdminLike = user.user_type === 'gods_eye' || user.user_type === 'manager';
    if (!isAdminLike && !hasModuleAccess(permissions, requiredModule)) {
      // Log for debugging
      console.warn(`Access denied for user ${user.user_type} to module ${requiredModule}`);
      // Return an access denied component instead of redirecting
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#f9fafb',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div>
            <h2>Access Denied</h2>
            <p>You do not have permission to access this module.</p>
            <p style={{ color: '#999', fontSize: '14px' }}>
              Your user type: {user.user_type}
            </p>
          </div>
        </div>
      );
    }
  }

  return children;
}
